module.exports = __webpack_public_path__ + "static/media/gallery2.a0487216.png";